/**
 * Per-feature copy — surface concrete value bullets, no marketing fluff.
 * Each entry is keyed by the feature id from FEATURE_PLAN_MAP.
 *
 * The icon component is resolved lazily via the consumer's prop when
 * available (cf. AppLayout — the lock click forwards the menu item's Icon),
 * so we don't need to import every Lucide icon here.
 *
 * Kept in a plain, JSX-free, dependency-free module (no react-router-dom,
 * no react-i18next) so it stays importable from unit tests without pulling
 * in the router — same pattern as preSignatureVerdict.js (Task 10) and
 * preSignatureRows.js (Task 11). UpgradeModal.jsx imports and re-exports
 * this for its own use and to keep existing consumers working.
 */
export const UPGRADE_COPY = {
  pre_signature: {
    titleKey: "upgrade.features.pre_signature.title",
    bulletsKey: "upgrade.features.pre_signature.bullets",
  },
  under_watch_full: {
    titleKey: "upgrade.features.under_watch_full.title",
    bulletsKey: "upgrade.features.under_watch_full.bullets",
  },
  crosscheck: {
    titleKey: "upgrade.features.crosscheck.title",
    bulletsKey: "upgrade.features.crosscheck.bullets",
  },
  executive_report: {
    titleKey: "upgrade.features.executive_report.title",
    bulletsKey: "upgrade.features.executive_report.bullets",
  },
  rapports_vigilance: {
    titleKey: "upgrade.features.rapports_vigilance.title",
    bulletsKey: "upgrade.features.rapports_vigilance.bullets",
  },
  daily_brief: {
    titleKey: "upgrade.features.daily_brief.title",
    bulletsKey: "upgrade.features.daily_brief.bullets",
  },
  cashflow_forecast: {
    titleKey: "upgrade.features.cashflow_forecast.title",
    bulletsKey: "upgrade.features.cashflow_forecast.bullets",
  },
  guardian_score: {
    titleKey: "upgrade.features.guardian_score.title",
    bulletsKey: "upgrade.features.guardian_score.bullets",
  },
  slack_notifications: {
    titleKey: "upgrade.features.slack_notifications.title",
    bulletsKey: "upgrade.features.slack_notifications.bullets",
  },
  lineage: {
    titleKey: "upgrade.features.lineage.title",
    bulletsKey: "upgrade.features.lineage.bullets",
  },
  alm_collaborative: {
    titleKey: "upgrade.features.alm_collaborative.title",
    bulletsKey: "upgrade.features.alm_collaborative.bullets",
  },
  export_csv: {
    titleKey: "upgrade.features.export_csv.title",
    bulletsKey: "upgrade.features.export_csv.bullets",
  },
  multi_users: {
    titleKey: "upgrade.features.multi_users.title",
    bulletsKey: "upgrade.features.multi_users.bullets",
  },
};
